import { EllipsisVerticalIcon } from '@heroicons/react/20/solid';

import { getInitials } from '@northladder/utilities';

import { TStatusConfig, StatusBadge, TRecordStatus } from '../StatusBadge';

import { AvatarV1 } from './Avatar';

export interface ISignUpsListingData {
  avatar?: string;
  id: string;
  name: string;
  country: string;
  email: string;
  mobile: string;
  company: string;
  position: string;
  source: string;
  createdAt: string;
  status: TRecordStatus;
}

interface ITableBodyCellProps {
  headerKey: keyof ISignUpsListingData;
  item: ISignUpsListingData;
}

/**
 * This renders
 */
export function TableBodyCell({
  headerKey,
  item,
}: Readonly<ITableBodyCellProps>) {
  const { name, createdAt, status } = item;

  // TODO: Add more options to this config on demand
  const statusInfo: TStatusConfig = {
    pending: {
      label: 'Pending',
      variant: 'info',
    },
    'in-review': {
      label: 'Pending',
      variant: 'warning',
    },
    approved: {
      label: 'Approved',
      variant: 'success',
    },
    accepted: {
      label: 'Accepted',
      variant: 'success',
    },
    rejected: {
      label: 'Rejected',
      variant: 'error',
    },
  };

  const { label, variant } = statusInfo[status] || {
    label: status,
    variant: 'outlined',
  };

  switch (headerKey) {
    case 'status':
      return (
        <StatusBadge
          className="min-w-24 w-fit text-center capitalize"
          label={label}
          type="solid"
          variant={variant}
        />
      );
    case 'avatar':
      return <AvatarV1>{getInitials(name)}</AvatarV1>;
    case 'createdAt':
      return new Date(createdAt).toLocaleString('en-In', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    case 'id':
      return (
        <span className="w-6">
          <EllipsisVerticalIcon />
        </span>
      );
    default:
      return item[headerKey];
  }
}

interface ITableHeaderCellProps {
  headerKey: string;
  label: string;
}
/**
 * It renders the cell for the table header
 */
export function TableHeaderCell({
  headerKey,
  label,
}: Readonly<ITableHeaderCellProps>) {
  switch (headerKey) {
    case 'avatar':
      return <span className="h-14 w-14 rounded-full border" />;
    case 'id':
      return (
        <span className="w-6">
          <EllipsisVerticalIcon />
        </span>
      );
    default:
      return label;
  }
}
